<template>
    <div v-if="displayNotifications.length > 0">
        <template v-for="notification in displayNotifications">
            <Component
                :is="notification"
                :data="notificationData[notification]"
                @dismiss-notification="dismissNotification"
            ></Component>
        </template>
    </div>
</template>

<script>
import {
    USER_NOTIFICATION_APPEND,
    USER_NOTIFICATION_HIDE,
    USER_NOTIFICATION_SHOW,
    USER_NOTIFICATIONS,
} from './user-notifications';
import UnconfirmedUserNotification from './UnconfirmedUserNotification.vue';
import EligibleForEducationalNotification from './EligibleForEducationalNotification.vue';
import { eventBus } from '../../../lib/event-bus/event-bus';
import EducationExpiredNotification from './EducationExpiredNotification.vue';

const notificationComponents = {
    [USER_NOTIFICATIONS.UNCONFIRMED_USER]: UnconfirmedUserNotification,
    [USER_NOTIFICATIONS.ELIGIBLE_FOR_EDUCATIONAL]: EligibleForEducationalNotification,
    [USER_NOTIFICATIONS.EDUCATION_EXPIRED]: EducationExpiredNotification,
};

export default {
    name: 'UserNotifications',
    components: notificationComponents,
    created() {
        eventBus.listen(USER_NOTIFICATION_APPEND, (notification) => {
            this.addNotification(notification.name, notification.data);
        });

        eventBus.listen(USER_NOTIFICATION_SHOW, (notification) => {
            if (this.displayNotifications.includes(notification.name)) {
                // notification already exists, ignore
                return;
            }

            this.addNotification(notification.name, notification.data);
        });

        eventBus.listen(USER_NOTIFICATION_HIDE, (notification) => {
            this.dismissNotification(notification);
        });
    },
    methods: {
        addNotification(notificationName, notificationData) {
            if (!Object.keys(notificationComponents).includes(notificationName)) {
                // notification not found, ignore
                return;
            }

            if (notificationData) {
                this.$set(this.notificationData, notificationName, notificationData);
            }

            this.displayNotifications.push(notificationName);
        },
        dismissNotification(notificationName) {
            const notificationIndex = this.displayNotifications.indexOf(notificationName);

            if (notificationIndex === -1) {
                // notification not found, ignore
                return;
            }

            this.displayNotifications.splice(notificationIndex, 1);

            if (this.notificationData[notificationName]) {
                this.$delete(this.notificationData, notificationName);
            }
        },
    },
    data() {
        return {
            displayNotifications: [],
            notificationData: {},
        };
    },
};
</script>

<style scoped></style>
